
app.service('CreationPlaceService', function (ApiService, $rootScope) {

    //add place 
    this.PlaceCreate = function (placevm) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/Place/PlaceCreate?lang=" + $rootScope.LangForWork, placevm)
      
       
        return request;
    }

    //var savedData = {}


    //function set(data) {
    //    savedData = data;
    //}
    //function get() {
    //    return savedData;
    //}

    //return {
    //    set: set,
    //    get: get
    //}


});

